<div class="content-box">
        <div class="title">Action Required ⚠️</div>
        <div class="text-content">
        <span class="subtitle">
          Your Capital (Cash) segment is not yet active.
        </span><br>
        <span class="subtitle">
        This segment is mandatory for activating NSE & BSE Derivatives.<br>
        Please connect with our Support Team for assistance and more details.
        </span>
        </div>
</div>
  